import axios from 'axios';

export const profileTaskApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/profile-task`,
    headers: {
        'Content-Type': 'application/json'
    }
})